import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/Header";
import HeroSection from "./HeroSection";
import ServiceCardsSection from "../sections/ServiceCardsSection";
import ProcessVisualization from "../sections/ProcessVisualization";
import Footer from "../layout/Footer";
import WhatsAppWidget from "../chat/WhatsAppWidget";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import ConsultationForm from "../forms/ConsultationForm";

const HomePage = () => {
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);

  const handleGetStartedClick = () => {
    setIsConsultationOpen(true);
  };

  // Listen for custom event to open consultation form
  React.useEffect(() => {
    const handleOpenConsultationForm = () => {
      setIsConsultationOpen(true);
    };

    document.addEventListener(
      "open-consultation-form",
      handleOpenConsultationForm,
    );

    return () => {
      document.removeEventListener(
        "open-consultation-form",
        handleOpenConsultationForm,
      );
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <HeroSection onGetStartedClick={handleGetStartedClick} />

      {/* Service Cards */}
      <ServiceCardsSection />
      <div className="flex justify-center py-8 bg-gray-50">
        <Button
          size="lg"
          onClick={handleGetStartedClick}
          className="px-8 py-6 text-lg bg-coral-600 hover:bg-coral-700 text-white shadow-lg"
        >
          Get a call back
        </Button>
      </div>

      {/* Process Visualization */}
      <ProcessVisualization />
      <div className="flex justify-center py-8 bg-white">
        <Button
          size="lg"
          onClick={handleGetStartedClick}
          className="px-8 py-6 text-lg bg-coral-600 hover:bg-coral-700 text-white shadow-lg"
        >
          Get a call back
        </Button>
      </div>

      {/* Footer */}
      <Footer />

      {/* WhatsApp Widget */}
      <WhatsAppWidget />

      {/* Consultation Form Dialog */}
      <Dialog open={isConsultationOpen} onOpenChange={setIsConsultationOpen}>
        <DialogContent className="sm:max-w-[600px] p-0">
          <ConsultationForm
            open={isConsultationOpen}
            onOpenChange={setIsConsultationOpen}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default HomePage;
